<template>
  <div id="mercadopagoBrick"></div>
</template>
<script>
import MercadopagoSdkMixin from '@/mixins/MercadopagoSdkMixin'

export default {
  name: 'mercadopago-brick',
  mixins: [
    MercadopagoSdkMixin
  ],
  props: {
    amount: {
      type: Number,
      required: true
    },
    payerEmail: {
      type: String,
      default: ''
    },
    primaryColor: {
      type: String,
      default: ''
    },
    publicKey: {
      type: String,
      required: true
    }
  },
  data: () => ({
    controller: null
  }),
  async mounted () {
    try {
      const mp = await this.initMercadopago(this.publicKey)
      this.controller = await mp.bricks().create('cardPayment', 'mercadopagoBrick', this.settings())
    } catch (error) {
      this.$emit('error', error.message || 'No pudimos cargar el formulario de pago.')
    }
  },
  beforeDestroy () {
    // Required: going back, switching ?experience= and navigating after a
    // payment all destroy this component. Without unmount the iframes are left
    // behind and the next create() on the same container id fails.
    if (this.controller) {
      this.controller.unmount()
      this.controller = null
    }
  },
  methods: {
    /**
     * Validate and tokenize. Returns the token id, or null when the form is
     * incomplete or Mercado Pago rejected the card data.
     *
     * Mirrors MercadopagoSecureFields.createToken so the container drives both
     * experiences through exactly the same call.
     */
    async createToken () {
      if (!this.controller) {
        this.$emit('error', 'No pudimos cargar el formulario de pago. Recarga la página.')
        return null
      }
      try {
        // getFormData() is the documented counterpart of hidePaymentButton: it
        // runs the Brick's own validation and resolves with the same payload
        // onSubmit would have received.
        const formData = await this.controller.getFormData()
        if (!formData || !formData.token) {
          this.$emit('error', 'Revisa los datos de tu tarjeta.')
          return null
        }
        return formData.token
      } catch (error) {
        // Rejects when the form is incomplete. The Brick already marks the
        // offending fields, so keep our message short.
        this.$emit('error', (error && error.message) || 'Revisa los datos de tu tarjeta.')
        return null
      }
    },
    settings () {
      const initialization = { amount: this.amount }
      if (this.payerEmail) {
        initialization.payer = { email: this.payerEmail }
      }
      return {
        initialization: initialization,
        callbacks: {
          onReady: () => {
            this.$emit('ready')
          },
          onError: (error) => {
            this.$emit('error', (error && error.message) || 'Revisa los datos de tu tarjeta.')
          }
        },
        customization: {
          paymentMethods: {
            // The API pins installments to 1 when it charges Mercado Pago, so
            // offering instalments here would show the payer a choice the
            // backend ignores.
            maxInstallments: 1,
            minInstallments: 1
          },
          visual: {
            hideFormTitle: true,
            // The Brick's own button gives no loading or disabled feedback, so
            // the payer cannot tell the click registered and clicks again --
            // the very thing that produced duplicate charges. We render our own
            // button instead and submit through getFormData().
            hidePaymentButton: true,
            style: {
              customVariables: {
                baseColor: this.primaryColor || '#1976D2',
                textPrimaryColor: '#525F7F',
                textSecondaryColor: '#6B8699',
                inputBackgroundColor: '#FFFFFF',
                formBackgroundColor: 'transparent',
                // The Brick ships its own form padding, which sits on top of
                // the v-card-text padding: the fields end up inset relative to
                // our full width Pagar button, with a gap above it. The card
                // already provides the spacing.
                formPadding: '0px',
                borderRadiusMedium: '6px',
                errorColor: '#FF5252',
                fontSizeMedium: '14px'
              }
            }
          }
        }
      }
    }
  }
}
</script>
